/* used for passing fromAddress in swap/quote requests with disabled wallet */
export const FAKE_WALLET_ADDRESS = '0xe388Ed184958062a2ea29B7fD049ca21244AE02e';
export const FAKE_SOLANA_WALLET_ADDRESS = '7cwWhuCJUHc27Dq4nQRhggwgeuVHEeS3NWv7BY6yY9Bk';
export const FAKE_TRON_WALLET_ADDRESS = 'TFwy9q45E5kK6HKzmc3gAcJY4rVD96VNi5';
export const FAKE_TON_ADDRESS = 'UQATSC4TXAqjgLswuSEDVTIGmPG_kNnUTDhrTiIILVmymoQA';
export const FAKE_BITCOIN_ADDRESS = 'bc1qw5as2wyl4s9g7lf4n2gp43zcj060q3jauuxzy7';
